import fetch from "../components/optionsFetch";
import * as React from 'react';
import Notifications from '../components/Notifications';
import DataGrid from '../components/DataGrid';
import { DateRangePicker } from '@progress/kendo-react-dateinputs';
import GetColumnDefs from '../components/ColumnDefs';
import { GetPermissions } from '../components/Options';
import { useNavigate } from "react-router-dom";
import configData from "../config.json";
import { GetSession, GetToken } from '../components/Session';
import { Button } from "@progress/kendo-react-buttons";
import { TextBox, Checkbox } from "@progress/kendo-react-inputs";
import { MultiSelect, DropDownList } from "@progress/kendo-react-dropdowns";
import { filterBy } from "@progress/kendo-data-query";
import { GetCloudLogin } from "../WeighBridge/Helpers";
import { Dialog, DialogActionsBar } from "@progress/kendo-react-dialogs";
import { getMultiSelectTreeValue } from "@progress/kendo-react-dropdowns";
import { processMultiSelectTreeData, expandedState } from "../components/multiselecttree-data-operations";
import { MultiSelectTreeEditor } from "../components/MultiSelectTreeEditor";
import AdvancedSearchNotice from "../components/AdvancedSearchNotice";
import { ExpansionPanel, ExpansionPanelContent } from "@progress/kendo-react-layout";
import { Reveal } from "@progress/kendo-react-animation";

const Transactions = () => {
    const [columns, setColumns] = React.useState(null);
    const [errorMessage, setErrorMessage] = React.useState("");
    const [permissions, setPermissions] = React.useState(null);
    const [expanded, setExpanded] = React.useState(false);
    const [searchResetKey, setSearchResetKey] = React.useState(0);
    const [filtersApplied, setFiltersApplied] = React.useState(() => Boolean(localStorage.getItem("TransactionDates")));
    const [sites, setSites] = React.useState([]);
    const [site, setSite] = React.useState([]);
    const [loadTypes, setLoadTypes] = React.useState([]);
    const [loadType, setLoadType] = React.useState([]);
    const [rego, setRego] = React.useState("");
    const [docket, setDocket] = React.useState("");
    const [statii, setStatii] = React.useState([]);
    const [status, setStatus] = React.useState("Active");
    const ready = React.useRef(false);
    const timeout = React.useRef(false);
    const navigate = useNavigate();
    const delay = 500;
    const [products, setProducts] = React.useState();
    const [jobs, setJobs] = React.useState();
    const [customers, setCustomers] = React.useState();
    const [productdata, setproductData] = React.useState();
    const [customerdata, setcustomerData] = React.useState();
    const [jobdata, setjobData] = React.useState();
    const cloudToken = React.useRef("");
    const options = React.useRef();
    const [cloudLogin, setCloudLogin] = React.useState("");
    const [dataSource, setDataSource] = React.useState("");
    const showSites = GetSession().SiteID === 1;
    const [showDialog, setShowDialog] = React.useState(false);
    const [dialogTitle, setDialogTitle] = React.useState("Refund Transaction");
    const [dialogOk, setDialogOk] = React.useState("Refund");
    const [dialogMsg, setDialogMsg] = React.useState("");
    const refundItem = React.useRef();
    const [adjInventory, setAdjInventory] = React.useState(false);
    const [forceUpdate, setForceUpdate] = React.useState("");
    
    if (permissions && !permissions.CanView) navigate("/error401");
    if (localStorage.getItem("userid") === null) navigate("/logout");

    const [layout, setLayout] = React.useState([
      { "field": "searchAdvanced", "label": "Advanced Search", "isVisible": true, "type": "heading" },
      { "field": "searchSite", "label": "Site", "isVisible": true, "type": "list" },
      { "field": "searchRego", "label": "Rego", "isVisible": true, "type": "text" },
      { "field": "searchDocket", "label": "Docket", "isVisible": true, "type": "text" },
      { "field": "searchLoadType", "label": "Load Type", "isVisible": true, "type": "list" },
      { "field": "searchJob", "label": "Job", "isVisible": true, "type": "list" },
      { "field": "searchProduct", "label": "Product", "isVisible": true, "type": "list" },
      { "field": "searchCustomer", "label": "Customer", "isVisible": true, "type": "list" },
      { "field": "searchStatus", "label": "Status", "isVisible": true, "type": "list" }
    ]);

    const subTotals = [
        { field: 'gross', aggregate: 'sum' },
        { field: 'gross1', aggregate: 'sum' },
        { field: 'gross2', aggregate: 'sum' },
        { field: 'gross3', aggregate: 'sum' },
        { field: 'gross4', aggregate: 'sum' },
        { field: 'gross5', aggregate: 'sum' },
        { field: 'tare', aggregate: 'sum' },
        { field: 'tare1', aggregate: 'sum' },
        { field: 'tare2', aggregate: 'sum' },
        { field: 'tare3', aggregate: 'sum' },
        { field: 'tare4', aggregate: 'sum' },
        { field: 'tare5', aggregate: 'sum' },
        { field: 'net', aggregate: 'sum' },
        { field: 'count', aggregate: 'sum' },
        { field: 'tranCost', aggregate: 'sum' },
        { field: 'totalCost', aggregate: 'sum' },
        { field: 'cartageCharge', aggregate: 'sum' },
        { field: 'cartageCost', aggregate: 'sum' },
        { field: 'gST', aggregate: 'sum' },
        { field: 'ePA', aggregate: 'sum' },
        { field: 'haulage', aggregate: 'sum' },
        { field: 'eftposCharge', aggregate: 'sum' },
        { field: 'creditCharge', aggregate: 'sum' },
        { field: 'totalFees', aggregate: 'sum' },
        { field: 'discounts', aggregate: 'sum' },
        { field: 'subTotal', aggregate: 'sum' }
    ];

    const [dateRange, setDateRange] = React.useState();
    const [lookupParams, setLookupParams] = React.useState("");

    let dt = new Date();
    let dr = { start: new Date(dt.getFullYear(), dt.getMonth(), dt.getDate()), end: new Date(dt.getFullYear(), dt.getMonth(), dt.getDate(), 23, 59, 59) };
    let td = localStorage.getItem("TransactionDates");
    
    const GetField = (f) => {
      return layout.find(obj => { return obj.field === f });
    }

    React.useEffect(() => { 
        let sess = GetSession();
        if (sess.SiteID !== 1 && sess.CloudURL !== "/") setCloudLogin("Logging into cloud...");
        GetCloudLogin((cred) => {
            cloudToken.current = (cred === "" ? "" : cred.token);
            if (sess.SiteID !== 1 && sess.CloudURL !== "/"){
                setCloudLogin("");
                if (cloudToken.current !== "")
                    setDataSource(" - Cloud Data");
                else
                    setDataSource(" - Local Data");
            }

            GetColumnDefs("Transactions", setColumns, setErrorMessage);
            GetPermissions(["ViewTransactionsPage", "NewTransaction", "EditTransaction", "DeleteTransaction", "ReportTransaction", "PrintTransaction"], setPermissions);
            let baseUrl = configData.SERVER_URL + "apiv7/userinterfaces?$filter=viewName eq 'Transactions'";
            const init = {
                method: "GET",
                accept: "application/json",
                headers: { "Authorization": "Bearer " + GetToken() },
            };
            fetch(baseUrl, init).then(response => response.json()).then(d => {
                if (GetSession().IsMobile) {
                    let data = [];
                    for (let i = 0; i < d.length; i++) {
                        data.push({ field: d[i].field, label: d[i].label, type: d[i].type, format: d[i].format, isVisible: d[i].isVisible && d[i].isVisibleOnMobile });
                    }
                    setLayout(data);
                } else {
                    setLayout(d);
                }
            });
            let dynUrl = ((cred.token === undefined || cred.token === null || cred.token === "") ? configData.SERVER_URL : GetSession().CloudURL);
            const dynInit = {
                method: 'GET',
                accept: 'application/json',
                headers: { "Authorization": "Bearer " + ((cred.token ===  undefined || cred.token === null || cred.token === "") ? GetToken() : cred.token) }
            }
            baseUrl = `${dynUrl}apiv7/options`;
            fetch(baseUrl, dynInit)
                .then((response) => response.json())
                .then((d) => {
                    options.current = d;
                    let lt = d.loadTypes.filter(obj => obj !== "First");
                    setLoadTypes(lt);
                    let st = [];
                    let sid = GetSession().SiteID;
                    if (sid === 1) {
                        st.push({ id: "1", name: "Cloud" });
                        for (var i = 0; i < d.sites.length; i++) {
                            st.push({ id: d.sites[i].id, name: d.sites[i].name });
                        }
                    } else {
                        st = [];
                        let s1 = d.sites.find(obj => { return obj.id === String(sid) });
                        if (s1 !== undefined) st.push({ id: s1.id, name: s1.name });
                    }
                    setSites(st);
                    ConfigureProducts(d.products);
                    ConfigureCustomers(d.customers);
                    ConfigureJobs(d.jobs);
                    setStatii(d.status);
                    ready.current = true;
                    setDateRange(dr);
                    DoSearch(dr);
                    if (td !== undefined && td !== "" && td !== null) {
                        setTimeout(() => { UpdateSavedParams() }, 100);
                    } else {
                        ClearParams();
                    }
                });
        });
    }, [])


    const CreateList = (d) => {
        var x = [{ id: "1", name: "NA" }];
        return x.concat(d);
      };

    const [showDateRange, setShowDateRange] = React.useState(false);
    const rangeChanged = (event) => {
        const newRange = event.value;

        setDateRange(newRange);

        if (newRange.start && newRange.end) {
            setShowDateRange(false);
        }
    };

    const UpdateSavedParams = () => {
        if (td === undefined) return;
        let def = JSON.parse(td);
        let allSites = [{ id: "1", name: "Cloud" }, ...options.current.sites];
        let st = [];
        if (def.Site !== undefined && def.Site !== null && def.Site !== "0") {
            let sp = def.Site.split(';');
            sp.forEach(s => {
                let f = allSites.find(obj => { return obj.id === s });
                if (f !== undefined) st.push({ id: f.id, name: f.name });
            });
        }
        setSite(st);
        let lt = [];
        if (def.LoadType !== "" && def.LoadType !== undefined ) lt = def.LoadType.split(';');
        setLoadType(lt);
        setRego(def.Rego);
        setDocket(def.Docket);
        let j = GetSelected(options.current.jobs, def.Job);
        setJobsValue(j);
        let c = GetSelected(options.current.customers, def.Customer);
        setCustomersValue(c);
        let p = GetSelected(options.current.products, def.Product);
        setProductsValue(p);
        dr = { start: new Date(def.FromDate), end: new Date(def.ToDate) };
        setDateRange(dr);
        setStatus(def.Status);
        var truckParam = {
            FromDate: dr.start.toISOString(),
            ToDate: dr.end.toISOString(),
            Rego: def.Rego,
            Docket: def.Docket,
            LoadType: GetLoadTypes(lt),
            Job: GetIds(j),
            Customer: GetIds(c),
            Site: GetIds(st), 
            Product: GetIds(p),
            Status: def.Status
        };
        setLookupParams(encodeURI(JSON.stringify(truckParam)));
    }

    const GetSelected = (c, d) => {
        let r = [];
        if (d === undefined || d === null || d === "0") return r;
        let sp = d.split(';');
        sp.forEach(s => {
            let f = c.find(obj => { return obj.id === s });
            if (f !== undefined) r.push({ id: f.id, text: f.name });
        });
        return r;
    }

    const exportRecord = (rec) => {
        const timeOffset = new Date().getTimezoneOffset() / 60;
        const baseUrl = (cloudToken.current !== undefined && cloudToken.current !== "" ? GetSession().CloudURL : configData.SERVER_URL);
        var url = `${baseUrl}apiv7/private/getdocketpdf?transactionid=${rec.transactionId}&offset=${timeOffset}`;
        const init = {
          method: 'GET',
          accept: 'application/json',
          headers: { "Authorization": "Bearer " + (cloudToken.current !== undefined && cloudToken.current !== "" ? cloudToken.current : GetToken()) }
        }
        return fetch(url, init).then(response => {
            if (!response.ok) throw new Error(`Docket export failed (${response.status}).`);
            return response.blob();
        }).then(d => { 
            var fileURL = URL.createObjectURL(d);
            var fileLink = document.createElement('a');
            fileLink.href = fileURL;
            fileLink.download = `docket_${rec.docket}.pdf`;
            document.body.appendChild(fileLink);
            fileLink.click();
            fileLink.remove();
            URL.revokeObjectURL(fileURL);
        });
    }

    const bulkExport = (rec) => {
        const timeOffset = new Date().getTimezoneOffset() / 60;
        const baseUrl = (cloudToken.current !== undefined && cloudToken.current !== "" ? GetSession().CloudURL : configData.SERVER_URL);
        var url = `${baseUrl}apiv7/private/getdocketzip?ids=${rec}&offset=${timeOffset}`;
        const init = {
          method: 'GET',
          headers: { "Authorization": "Bearer " + (cloudToken.current !== undefined && cloudToken.current !== "" ? cloudToken.current : GetToken()) }
        }
        return fetch(url, init).then(response => { if (!response.ok) throw new Error(`Bulk download failed (${response.status}).`); return response.blob(); }).then(d => { 
            var fileURL = URL.createObjectURL(d);
            var fileLink = document.createElement('a');
            fileLink.href = fileURL;
            fileLink.download = `docket.zip`;
            document.body.appendChild(fileLink);
            fileLink.click();
            fileLink.remove();
            URL.revokeObjectURL(fileURL);
        });
    }

    const loadTypeChanged = (event) => {
        setLoadType(event.target.value);
    };
    const siteChanged = (event) => {
        setSite(event.target.value);
    };
    const statusChanged = (event) => {
        setStatus(event.target.value);
    };
    const regoChanged = (event) => {
        setRego(event.target.value);
    }
    const docketChanged = (event) => {
        setDocket(event.target.value);
    }

    const searchClicked = () => {
        let tp = DoSearch(dateRange);
        localStorage.setItem("TransactionDates", JSON.stringify(tp));
        setFiltersApplied(true);
    }

    const DoSearch = (dt) => {
        let defSite = String(GetSession().SiteID);
        if (defSite === "1") defSite = "0";
        var truckParam = {
            FromDate: dt.start === null ? "2000-01-01T00:00:00Z" : dt.start.toISOString(),
            ToDate: dt.end === null ? "2050-01-01T00:00:00Z" : dt.end.toISOString(),
            Rego: rego === undefined ? "" : rego,
            Docket: docket === undefined ? "" : docket,
            LoadType: loadType === undefined ? "0" : GetLoadTypes(loadType),
            Job: jobsValue === undefined ? "0" : GetIds(jobsValue),
            Customer: customersValue === undefined ? "0" : GetIds(customersValue),
            Site: site === undefined || site.length === 0 ? defSite : GetIds(site),
            Product: productsValue === undefined ? "0" : GetIds(productsValue),
            Status: status === undefined ? "Active" : status
        };       
        setLookupParams(encodeURI(JSON.stringify(truckParam)));
        return truckParam;
    }

    const GetIds = (d) => {
        if (d === null || d.length === undefined || d.length === 0) return "0";
        let r = "";
        d.map(x => {
            if (x !== undefined && x.id !== undefined) r += (r.length > 0 ? ";" : "") + x.id;
            return "";
        });
        return r;
    }

    const GetLoadTypes = (loadType) => {
        if (loadType === "" || loadType === undefined) return "";
        let r = "";
        loadType.map(x => {
            r += (r.length > 0 ? ";" : "") + x;
        })
        return r;
    }

    const ClearSearch = (dr) => {
        if (ready.current) {
            ClearParams();
            let defSite = String(GetSession().SiteID);
            if (defSite === "1") defSite = "0";
            var truckParam = {
                FromDate: dr.start.toISOString(),
                ToDate: dr.end.toISOString(),
                Rego: "",
                Docket: "",
                LoadType: "",
                Job: "0",
                Customer: "0",
                Site: defSite,
                Product: "0",
                Status: "Active"
            };
            setLookupParams(encodeURI(JSON.stringify(truckParam)));
            localStorage.removeItem("TransactionDates");
        }
    }

    const clearClicked = () => {
        let dt = new Date();
        dr = { start: new Date(dt.getFullYear(), dt.getMonth(), dt.getDate()), end: new Date(dt.getFullYear(), dt.getMonth(), dt.getDate(), 23, 59, 59) };
        ClearSearch(dr);
        setSearchResetKey(key => key + 1);
        setFiltersApplied(false);
    }

    const ClearParams = () => {
        setRego("");
        setDocket("");
        setDateRange(dr);
        setLoadType([]);
        setJobsValue([]);
        setCustomersValue([]);
        setSite([]);
        setProductsValue([]);
        setStatus("Active");
    };
  
    const filterproductData = (filter) => {
        const productdata = products.slice();
        return filterBy(productdata, filter);
    };
    const filterprodChange = (event) => {
        setproductData(filterproductData(event.filter));
    };

    const filterjobtData = (filter) => {
        const jobdata = jobs.slice();
        return filterBy(jobdata, filter);
    };
    const filterjobChange = (event) => {
        setjobData(filterjobtData(event.filter));
    };

    const filtercustomerData = (filter) => {
        const customerdata = customers.slice();
        return filterBy(customerdata, filter);
    };
    const filtercustChange = (event) => {
        setcustomerData(filtercustomerData(event.filter));
    };

    const onKeyDown = (ev) => {
        ev.stopPropagation();
    };

    const RefundCommand = (item) => {
        setDialogTitle(`Confirm Refund of Docket ${item.docket}`);
        setShowDialog(true);
        refundItem.current = item;
        setDialogMsg(item.isRefunded === "Yes" ? "Do you want to cancel the refund?" : "Do you want to refund this item?");
        setDialogOk(item.isRefunded === "Yes" ? "Reverse" : "Refund");
    }

    const DialogYes = () => {
        setShowDialog(false);
        var url = `${configData.SERVER_URL}apiv7/transactions?id=${refundItem.current.transactionId}&adjustInventory=${adjInventory}`;
        const init = {
            method: 'PATCH',
            accept: "application/json",
            headers: {
                "Content-type": "application/json",
                "Authorization": "Bearer " + GetToken()
            },
            mode: "cors",
            cache: "no-cache",
        }
        fetch(url, init).then(res => res.text()).then(d => {
            alert("Refund updated");
            setForceUpdate(new Date());
        });
    }

    const DialogNo = () => {
        setShowDialog(false);
    }

    const InventoryChanged = (e) => { setAdjInventory(e.value) }

    const dataItemKey = "id";
    const checkField = "checkField";
    const checkIndeterminateField = "checkIndeterminateField";
    const subItemsField = "items";
    const expandField = "expanded";
    const textField = "text";
    const fields = { dataItemKey, checkField, checkIndeterminateField, expandField, subItemsField };

    const GetConfigData = (act) => {
        let sl = [];
        let selected = [];
        for (let i = 0; i < act.length; i++) {
            let entry = { text: act[i].name, id: act[i].id };
            sl.push(entry);
            selected.push(entry);
        }
        let active = { id: 0, text: 'All', items: sl };
        return { active: active, selected: selected };
    }

    // state data for PRODUCT multi-select tree   
    const [productsData, setProductsData] = React.useState([{ id: 0, text: "All", items: [] }]);
    const [productsValue, setProductsValue] = React.useState([]);
    const [productExpanded, setProductExpanded] = React.useState([]);
    const onProductsChange = (event) => {
        setProductsValue(getMultiSelectTreeValue(productsData, { ...fields, ...event, value: productsValue, }));
    }
    const onProductsExpandChange = React.useCallback((event) => setProductExpanded(expandedState(event.item, dataItemKey, productExpanded)), [productExpanded]);
    const productsTreeData = React.useMemo(() =>
        processMultiSelectTreeData(productsData, { expanded: productExpanded, value: productsValue, ...fields }), [productsData, productExpanded, productsValue]
    );
    const ConfigureProducts = (act) => {
        let x = GetConfigData(act);
        setProductsData([x.active]);
        return [];
    }
    const ProductChanged = (event) => {
        let v = null;
        if (event.value !== null) v = event.value.filter((n) => { return n.id !== 0 });
        setProductsValue(v);
    };

    // state data for JOB multi-select tree   
    const [jobsData, setJobsData] = React.useState([{ id: 0, text: "All", items: [] }]);
    const [jobsValue, setJobsValue] = React.useState([]);
    const [jobExpanded, setJobExpanded] = React.useState([]);
    const onJobsChange = (event) => {
        setJobsValue(getMultiSelectTreeValue(jobsData, { ...fields, ...event, value: jobsValue, }));
    }
    const onjobsExpandChange = React.useCallback((event) => setJobExpanded(expandedState(event.item, dataItemKey, jobExpanded)), [jobExpanded]);
    const jobsTreeData = React.useMemo(() =>
        processMultiSelectTreeData(jobsData, { expanded: jobExpanded, value: jobsValue, ...fields }), [jobsData, jobExpanded, jobsValue]
    );
    const ConfigureJobs = (act) => {
        let x = GetConfigData(act);
        setJobsData([x.active]);
        return [];
    }
    const JobChanged = (event) => {
        let v = null;
        if (event.value !== null) v = event.value.filter((n) => { return n.id !== 0 });
        setJobsValue(v);
    };

    // state data for CUSTOMER multi-select tree   
    const [customersData, setCustomersData] = React.useState([{ id: 0, text: "All", items: [] }]);
    const [customersValue, setCustomersValue] = React.useState([]);
    const [customerExpanded, setCustomerExpanded] = React.useState([]);
    const onCustomersChange = (event) => {
        setCustomersValue(getMultiSelectTreeValue(customersData, { ...fields, ...event, value: customersValue, }));
    }
    const oncustomersExpandChange = React.useCallback((event) => setCustomerExpanded(expandedState(event.item, dataItemKey, customerExpanded)), [customerExpanded]);
    const customersTreeData = React.useMemo(() =>
        processMultiSelectTreeData(customersData, { expanded: customerExpanded, value: customersValue, ...fields }), [customersData, customerExpanded, customersValue]
    );
    const ConfigureCustomers = (act) => {
        let x = GetConfigData(act);
        setCustomersData([x.active]);
        return [];
    }
    const CustomerChanged = (event) => {
        let v = null;
        if (event.value !== null) v = event.value.filter((n) => { return n.id !== 0 });
        setCustomersValue(v);
    };

    const today = new Date().toDateString();
    const hasCustomDates = dateRange && [dateRange.start, dateRange.end]
        .some(date => !date || new Date(date).toDateString() !== today);
    const defaultSiteId = String(GetSession().SiteID) === "1" ? "0" : String(GetSession().SiteID);
    const hasAdvancedSearchChanges = Boolean(
        rego || docket || loadType?.length || jobsValue?.length || productsValue?.length ||
        customersValue?.length || status !== "Active" || hasCustomDates ||
        site?.some(item => String(item.id) !== "0" && String(item.id) !== defaultSiteId)
    );

    return (
        <div>
        <Notifications errorMessage={errorMessage}/>
        {GetField("searchAdvanced")["isVisible"] && <ExpansionPanel
            className="wm-advanced-search wm-advanced-search--kendo wm-advanced-search--transactions"
            title={GetField("searchAdvanced")["label"] + dataSource}
            subtitle={filtersApplied ? <AdvancedSearchNotice active={filtersApplied} /> : null}
            expandIcon="fa fa-plus"
            collapseIcon="fa fa-minus"
            expanded={expanded}
            onAction={(e) => setExpanded(!e.expanded)}>
            <Reveal>
                {expanded && (
                    <ExpansionPanelContent>
                        <div id="transaction-advanced-search" className="wm-advanced-search__fields">
                            {showSites && GetField("searchSite")["isVisible"] && (
                                <div className="wm-advanced-search__field">
                                    <label htmlFor="Site">{GetField("searchSite")["label"]}</label>
                                    <MultiSelect id="Site" data={sites} textField="name" dataItemKey="id" value={site} onChange={siteChanged} placeholder="Select site" />
                                </div>
                            )}
                            {GetField("searchRego")["isVisible"] && (
                                <div className="wm-advanced-search__field" onKeyDown={onKeyDown}>
                                    <label htmlFor="Rego">{GetField("searchRego")["label"]}</label>
                                    <TextBox id="Rego" type="text" value={rego} onChange={regoChanged} placeholder="Enter registration" />
                                </div>
                            )}
                            {GetField("searchDocket")["isVisible"] && (
                                <div className="wm-advanced-search__field" onKeyDown={onKeyDown}>
                                    <label htmlFor="Docket">{GetField("searchDocket")["label"]}</label>
                                    <TextBox id="Docket" type="text" value={docket} onChange={docketChanged} placeholder="Enter docket no." />
                                </div>
                            )}
                            {GetField("searchLoadType")["isVisible"] && (
                                <div className="wm-advanced-search__field">
                                    <label htmlFor="LoadType">{GetField("searchLoadType")["label"]}</label>
                                    <MultiSelect id="LoadType" data={loadTypes} value={loadType} onChange={loadTypeChanged} placeholder="Select load type" />
                                </div>
                            )}
                            <div className="wm-advanced-search__field wm-advanced-search__date">
                                <DateRangePicker id="DateRange" value={dateRange} format="dd/MM/yyyy" onChange={rangeChanged}
                                    calendarSettings={{ views: 1 }}
                                    popupSettings={{
                                        popupClass: "wm-transaction-date-popup",
                                        anchorAlign: { horizontal: "right", vertical: "bottom" },
                                        popupAlign: { horizontal: "right", vertical: "top" },
                                        collision: { horizontal: "fit", vertical: "flip" }
                                    }}
                                    startDateInputSettings={{ label: "Date - Start" }}
                                    endDateInputSettings={{ label: "Date - End" }}
                                />
                            </div>
                            {GetField("searchJob")["isVisible"] && (
                                <div className="wm-advanced-search__field MSTree">
                                    <label>Job</label>
                                    <MultiSelectTreeEditor name="Job" data={jobsTreeData} value={jobsValue} dataItemKey={dataItemKey} checkField={checkField} size="large" onChange={JobChanged} textField="name" filterable={true} onFilterChange={filterjobChange} placeholder="Select job" />
                                </div>
                            )}
                            {GetField("searchProduct")["isVisible"] && (
                                <div className="wm-advanced-search__field MSTree">
                                    <label>Product</label>
                                    <MultiSelectTreeEditor name="productId" data={productsTreeData} value={productsValue} dataItemKey={dataItemKey} checkField={checkField} size="large" onChange={ProductChanged} textField="name" filterable={true} onFilterChange={filterprodChange} placeholder="Select product" />
                                </div>
                            )}
                            {GetField("searchCustomer")["isVisible"] && (
                                <div className="wm-advanced-search__field MSTree">
                                    <label>Customer</label>
                                    <MultiSelectTreeEditor name="customerId" data={customersTreeData} value={customersValue} dataItemKey={dataItemKey} checkField={checkField} size="large" onChange={CustomerChanged} textField="name" filterable={true} onFilterChange={filtercustChange} placeholder="Select customer" />
                                </div>
                            )}
                            {GetField("searchStatus")["isVisible"] && (
                                <div className="wm-advanced-search__field">
                                    <label htmlFor="Status">{GetField("searchStatus")["label"]}</label>
                                    <DropDownList id="Status" data={statii} value={status} onChange={statusChanged} defaultItem="Select status" />
                                </div>
                            )}
                            <div className="wm-advanced-search__actions">
                                <Button onClick={searchClicked} themeColor="primary" icon="search">Search</Button>
                                {hasAdvancedSearchChanges && <Button type="button" themeColor="error" className="wm-search-clear" onClick={clearClicked} icon="reset">Clear</Button>}
                            </div>
                        </div>
                    </ExpansionPanelContent>
                )}
            </Reveal>
        </ExpansionPanel>}
            {cloudLogin && <div className="cloudMessage">{cloudLogin}</div> }
            {columns && permissions && <DataGrid searchResetKey={searchResetKey} dataSource='apiv7/transactions' viewName='Transactions' exportRecord={exportRecord} bulkExport={bulkExport} columns={columns} permissions={permissions} params={lookupParams} keyField="transactionId" cloudToken={cloudToken.current} subTotals={subTotals} options={options.current} customCommandName="RefundCommand" customCommand={RefundCommand} update={forceUpdate} />}
            {showDialog && <Dialog title={dialogTitle} onClose={DialogNo}>
                <div style={{ paddingBottom: "20px" }}>{dialogMsg}</div>
                <div className="row">
                    <div className="col-md-1"><Checkbox onChange={InventoryChanged} size={"large"} /></div>
                    <div className="col-md-6">Update Inventory</div>
                </div>
                <DialogActionsBar>
                    <button className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base" onClick={DialogNo}>Cancel</button>
                    <button className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base" onClick={DialogYes}>{dialogOk}</button>
                </DialogActionsBar>
            </Dialog>}

        </div>       
    );

}

export default Transactions;




